import React from 'react';
import { formatLineDimensions, type LineDimensionSource } from '../../utils/productDimensions';
import './ProductNameWithDimensions.css';

export type ProductDimensionSource = LineDimensionSource;
/** A document line keyed by id (e.g. a ZD line) carrying its dimensions. */
export type ProductDimensionLine = ProductDimensionSource & { id: string };

interface ProductNameWithDimensionsProps {
  name: React.ReactNode;
  /** Line or catalog row: width/height/length/thickness, optional catalogProduct* fallback, category profile. */
  dimensions?: ProductDimensionSource | null;
  dimensionsTestId?: string;
}

/**
 * Product name, then the dimensions string on a muted 12 px line beneath
 * (only when the line has dimensions). The one „name + dimensions” cell:
 * new list/table/modal rows use it (components/AGENTS.md).
 */
const ProductNameWithDimensions: React.FC<ProductNameWithDimensionsProps> = ({
  name,
  dimensions,
  dimensionsTestId,
}) => {
  const text = formatLineDimensions(dimensions) ?? '';
  return (
    <span className="product-name-with-dimensions">
      <span>{name}</span>
      {text ? (
        <span className="product-name-with-dimensions__dimensions" data-testid={dimensionsTestId} title={text}>
          {text}
        </span>
      ) : null}
    </span>
  );
};

export default ProductNameWithDimensions;
